import React, { useEffect } from 'react';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';

// Local images
import cashew from '../assets/banners/cashew.jpg';
import almonds from '../assets/banners/almonds.jpg';
import spices from '../assets/banners/spices.jpg';
import basmati from '../assets/banners/basmati.jpg';
import cardamom from '../assets/banners/cardamons.jpg';
import blackPepper from '../assets/banners/black-pepper.avif';
import pistachios from '../assets/banners/pistachios.jpg';
import raisins from '../assets/banners/raisins.jpg';
import cloves from '../assets/banners/cloves.jpg';

const Products = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const allProducts = [
        { name: 'Cashew', image: cashew },
        { name: 'Almonds', image: almonds },
        { name: 'Pistachios', image: pistachios }, // no local image
        { name: 'Raisins', image: raisins },    // no local image
        { name: 'Cloves', image: cloves },     // no local image
        { name: 'Cardamom', image: cardamom },
        { name: 'Black Pepper', image: blackPepper },
        { name: 'Garam Masala', image: spices },
        { name: 'Basmati Rice', image: basmati }
    ];

    return (
        <div className="text-gray-800 bg-white">
            {/* Hero Section */}
            <section className="bg-yellow-100 py-16 px-4 text-center" data-aos="fade-down">
                <h1 className="text-4xl font-bold text-yellow-700 mb-4">Explore Our Finest Selection</h1>
                <p className="text-lg text-gray-700 max-w-2xl mx-auto">
                    Discover a premium range of dry fruits, spices, and rice—sourced from the best, packed with care, and delivered globally.
                </p>
            </section>

            {/* All Products Section */}
            <section className="max-w-7xl mx-auto px-4 py-16">
                <h2 className="text-3xl font-bold text-center text-yellow-600 mb-12" data-aos="fade-up">
                    Our Products
                </h2>
                <div className="grid md:grid-cols-4 sm:grid-cols-2 gap-8" data-aos="fade-up">
                    {allProducts.map((item, idx) => {
                        const path = item.name.toLowerCase().replace(/\s+/g, '-');
                        const imgSrc = item.image || `https://source.unsplash.com/300x200/?${item.name.replace(/ /g, '+')}`;

                        return (
                            <Link
                                key={idx}
                                to={`/product/${path}`}
                                className="bg-white border border-yellow-100 shadow-lg hover:shadow-2xl rounded-xl overflow-hidden transition-transform transform hover:-translate-y-1 hover:scale-105"
                                data-aos="zoom-in"
                            >
                                <img
                                    src={imgSrc}
                                    alt={item.name}
                                    className="w-full h-48 object-cover"
                                />
                                <div className="p-4 text-center">
                                    <h3 className="font-semibold text-lg text-gray-800">{item.name}</h3>
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Products;
